import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  cardActionButton: {
    backgroundColor: 'unset',
  },
}));

export default useStyles;
